// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/**
 * How To Use
 * 1. add this line to CustomFieldDefinition.ts
 *    export interface IconFieldTemplateDefinition extends BaseFieldDefinition<"PaddingField", Padding> {}
 * 2. Add Field to your widget
 *      {
 *           name: "icon",
 *           displayName: "Icon",
 *           editorTemplate: "IconField",
 *           defaultValue: {},
 *           fieldType: "General",
 *      },
 * 3. In your CSS use this function:  generatePaddingStyles(zoneOptions.padding)
 *    and it will handle fetch padding data in your code
 */

/* eslint-disable spire/fenced-imports */
import { CustomEditorTemplateProps, IconFieldTemplateDefinition } from "@synd/CustomFieldDefinition";
import xIconsObject from "@synd/XDL/Icons/xngCommonIcons";
import { getIcon } from "@synd/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Clickable from "@insite/mobius/Clickable";
import Icon from "@insite/mobius/Icon";
import StandardControl from "@insite/shell-public/Components/StandardControl";
import * as React from "react";
import { css } from "styled-components";

type Props = CustomEditorTemplateProps<string, IconFieldTemplateDefinition>;

class IconField extends React.Component<Props> {
    onChange = (value: string) => {
        this.props.updateField(this.props.fieldDefinition.name, value);
    };

    render() {
        const { item, fieldDefinition, fieldValue } = this.props;

        return (
            <StandardControl fieldDefinition={fieldDefinition as any}>
                <StyledWrapper
                    css={css`
                        display: grid;
                        grid-template-columns: repeat(auto-fill, minmax(40px, 1fr));
                        grid-template-rows: repeat(auto-fill, minmax(40px, 1fr));
                        gap: 12px;
                        justify-items: center;
                        max-height: 200px;
                        overflow-y: auto;
                        border: 1px solid #000;
                        border-radius: 4px;
                        padding: 8px;
                        margin-top: 10px;
                    `}
                >
                    {Object.keys(xIconsObject).map(iconName => (
                        <Clickable
                            onClick={() => this.onChange(iconName)}
                            key={iconName}
                            className={fieldValue === iconName ? "active" : ""}
                            css={css`
                                width: 35px;
                                height: 35px;
                                display: flex;
                                align-items: center;
                                justify-content: center;

                                &.active,
                                &:hover {
                                    background-color: #f0f0f0;
                                }
                            `}
                        >
                            <Icon
                                {...getIcon(iconName, 24)}
                                css={css`
                                    border-radius: 2px;
                                    justify-content: center;

                                    & svg {
                                        height: 24px;
                                        width: initial;
                                    }
                                `}
                            />
                        </Clickable>
                    ))}
                </StyledWrapper>
            </StandardControl>
        );
    }
}

export default IconField;
